import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/warehouse',
  component: () => import('@views/Warehouse/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'wh.index',
      component: () => import('@/components/Warehouse/WarehouseIndex')
    },
    {
      path: 'form/:id',
      name: 'wh.form',
      component: () => import('@/components/Warehouse/WarehouseForm'),
    },
    {
      path: 'form/disposal/:id',
      name: 'wh.form.disposal',
      component: () => import('@/components/Warehouse/WarehouseForm'),
    },
    {
      path: 'form/surplus/:id',
      name: 'wh.form.surplus',
      component: () => import('@/components/Warehouse/WarehouseFormSurplus'),
    },
    {
      path: 'form/contaminate/:id',
      name: 'wh.form.contaminate',
      component: () => import('@/components/Warehouse/WarehouseFormContaminate'),
    },
    {
      path: 'form/courtesy/:id',
      name: 'wh.form.courtesy',
      component: () => import('@/components/Warehouse/WarehouseFormCourtesy'),
    },
    {
      path: 'form/repair_return/:id',
      name: 'wh.form.repair_return',
      component: () => import('@/components/Warehouse/WarehouseFormRepairReturn'),
    },
    {
      path: 'filter/:returntype',
      name: 'wh.filter',
      component: () => import('@/components/Warehouse/WarehouseIndex')
    },
    {
      path: 'contaminate',
      name: 'wh.contaminate',
      component: () => import('@/components/ReceiveContaminate/ReceiveContaminate')
    }
  ]
}
